module.exports = __webpack_public_path__ + "static/media/logo.f443c8c4.svg";